import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { QueryParamsModel } from 'src/app/core/models/query-params.model';

import { ErrorService } from 'src/app/services/error.service';
import { environment } from 'src/environments/environment';
import * as CatalogActions from '../actions/catalog.actions';
import { AppState } from '../app.reducer';

@Injectable()
export class CatalogEffects {
  constructor(
    public actions$: Actions,
    public http: HttpClient,
    private errorService: ErrorService,
    private store: Store<AppState>
  ) { }
  payloadReload;

  getCatalog$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CatalogActions.getCatalog),
      switchMap((payload) => {
        const query = { ...payload.payload, filters: JSON.stringify(payload.payload.filters) };
        this.store.dispatch(CatalogActions.catalogLoading({ payload: { loading: true } }));
        this.payloadReload = payload.payload;
        const queryPayload = {
          filters: query.filters,
          sortOrder: query.sortOrder,
          sortField: query.sortField,
          pageNumber: query.pageNumber.toString(),
          pageSize: query.pageSize.toString(),
        };
        return this.http
          .get<{ data: any[]; query: QueryParamsModel; totalCount: number }>(
            environment.apiUrl + '/props',
            {
              params: queryPayload,
            }
          )
          .pipe(
            switchMap((responseData) => {
              this.store.dispatch(
                CatalogActions.getCatalogSuccess({
                  payload: {
                    catalog: responseData.data,
                    totalCount: +responseData.totalCount,
                  },
                })
              );
              return of(CatalogActions.catalogLoading({ payload: { loading: false } }));
            }),
            catchError((error) => {
              this.store.dispatch(
                CatalogActions.catalogFail({ payload: { error: this.errorService.mapError(error) } })
              );
              return of(CatalogActions.catalogLoading({ payload: { loading: false } }));
            })
          );
      })
    )
  );

}
